import { EventWithSubEvents } from '@lib/types/EventWithSubEvents';
import { Box } from "@mui/material";
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { FC } from 'react';
import EventTreeItem from '../EventTreeItem';

interface EventListProps {
    events: EventWithSubEvents[];
    keyPrefix: string;
    selectedEventIds?: string[];
    onSelectionChange?: (eventId: string) => void;
}

/**
 * Renders a list of events using TreeView components with proper overflow handling
 */
const EventList: FC<EventListProps> = ({ events, keyPrefix, selectedEventIds, onSelectionChange }) => {
    return (
        <>
            {events.map(event =>
                <Box
                    key={`${keyPrefix}-event-${event.event.id}`}
                    sx={{ mb: 1, ml: 2, maxWidth: '100%', overflow: 'hidden' }}
                >
                    <SimpleTreeView>
                        <EventTreeItem
                            event={event}
                            selectedEventIds={selectedEventIds}
                            onSelectionChange={onSelectionChange}
                        />
                    </SimpleTreeView>
                </Box>
            )}
        </>
    );
};

export default EventList;
